module.exports = __webpack_public_path__ + "img/14xlsqxt.f39f3cf5.svg";